export const ar = {
	signin: "تسجيل الدخول",
};
